import { ACTIONS, COLUMN_TYPE, EMPLOYEE_VALUES_DEFAULT } from '../../../../utils/financialHelper';
import FormEmpregados from './FormEmpregados';
import useCrud from '../../../../hooks/useCrud';
import CrudTablePage from '../../../../components/Financial/CrudTablePage';

const Empregados = () => {
  const headCells = [
    { key: 'fullName', field: 'fullName', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Nome' },
    { key: 'position', field: 'position', type: COLUMN_TYPE.STRING, alignRight: true, label: 'Cargo' },
    { key: 'department', field: 'department', type: COLUMN_TYPE.STRING, alignRight: true, label: 'Departamento' },
    { key: 'salary', field: 'salary', type: COLUMN_TYPE.MONEY, alignRight: true, label: 'Salário' },
    { key: 'actions', field: 'actions', type: COLUMN_TYPE.BUTTONS, alignRight: true, label: 'Ações' },
  ];

  const funcionalidade = 'Empregados'

  const {
    action,
    buttonLabel,
    dadoFoiModificado,
    filterValue,
    isLoading,
    isLoadingSubmit,
    items: empregados,
    open,
    title,
    values,
    setAction,
    setButtonLabel,
    setDadoFoiModificado,
    setFilterValue,
    setItems: setEmpregados,
    setValues,
    handleClose,
    handleDelete,
    handleEdit,
    handleOpen,
    handleSubmit,
    handleView,
  } = useCrud('/employees', EMPLOYEE_VALUES_DEFAULT, funcionalidade);

  return (
    <CrudTablePage
      isLoading={isLoading}
      funcionalidade={funcionalidade}
      rows={empregados}
      setRows={setEmpregados}
      headCells={headCells}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      filterValue={filterValue}
      setFilterValue={setFilterValue}
      dadoFoiModificado={dadoFoiModificado}
      setDadoFoiModificado={setDadoFoiModificado}
      open={open}
      title={title}
      buttonLabel={buttonLabel}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      action={action}
      handleOpen={handleOpen}
    >
      <FormEmpregados
        values={values}
        setValues={setValues}
        isDelete={action === ACTIONS.DELETE}
        isLoadingSubmit={isLoadingSubmit}
      />
    </CrudTablePage>
  )
};

export default Empregados;